// extracted by mini-css-extract-plugin
export default {"partner":"Partner_partner__F4Igv"};